/** @jsxImportSource @emotion/react */
import "./shared/styles/App.css";
import { BrowserRouter } from "react-router-dom";
import { Estetica, FooterMorfeo } from "./shared";
import Router from "./Router";

// PrimeReact imports
import { PrimeReactProvider } from "primereact/api";
import "primereact/resources/themes/lara-light-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";
import "./shared/styles/themeCustomization.css";

// Todo el portal público va sobre el color principal del organismo. Las
// páginas públicas de muestra/caja pintan su propio fondo aparte, así que no
// dependen de esto.
function Shell() {
  return (
    <div css={{ backgroundColor: "var(--principal)" }}>
      <Router />
      <FooterMorfeo claro />
    </div>
  );
}

export default function App() {
  return (
    <PrimeReactProvider>
      <Estetica app="PUBLIC">
        <BrowserRouter>
          <Shell />
        </BrowserRouter>
      </Estetica>
    </PrimeReactProvider>
  );
}
